
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiDatiGrid extends Serenity.EntityGrid<UtentiDatiRow, any> {
        protected getColumnsKey() { return UtentiDatiColumns.columnsKey; }
        protected getDialogType() { return UtentiDatiDialog; }
        protected getIdProperty() { return UtentiDatiRow.idProperty; }
        protected getInsertPermission() { return UtentiDatiRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiDatiRow.localTextPrefix; }
        protected getService() { return UtentiDatiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

            //
            //Q.reloadLookup("");
        }
    }
}